namespace GeniuzPOS.Lookups {
    export namespace VwIcWhsService {
        export const baseUrl = 'Lookups/VwIcWhs';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwIcWhsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwIcWhsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwIcWhs/Retrieve",
            List = "Lookups/VwIcWhs/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwIcWhsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
